import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const pCtContractSupervisorUpdate = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios
                .post(URL_API(`${servicelist.CtService}p_ct_contract_supervisor_update`), body, authorization)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
